const chartLineColorsByColorCode = {
  '#007882': 'aqua', //chart aqua
  '#0053a3': 'blue', //chart blue
  '#1b34ad': 'sapphire', //chart sapphire
  '#007c50': 'pine-green', //chart pine green
  '#3f1daa': 'daisy-bush', //chart daisy bush
  '#7f3785': 'violet', //chart violet
  '#5a8010': 'green', //chart green
  '#512d6e': 'purple', //chart purple
  '#60492C': 'brown'// chart brown
};

export default chartLineColorsByColorCode;
